// WebComponent
if (!customElements.get('media-card-gallery-with-text-block')) {
    class MediaCardGalleryWithTextBlock extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.swiperContainer = this.querySelector('.media-card-gallery-with-text-block-swiper');
            this.prevBtn = this.querySelector('.swiper-button-prev');
            this.nextBtn = this.querySelector('.swiper-button-next');
            this.pagination = this.querySelector('.swiper-pagination');
        }

        connectedCallback() {
            this.initSwiper();
        }

        initSwiper() {
            if (this.swiperContainer) {
                this.swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: this.nextBtn,
                        prevEl: this.prevBtn,
                    },
                    pagination: {
                        el: this.pagination,
                        clickable: true,
                    },
                });
            }
        }
    }
    customElements.define('media-card-gallery-with-text-block', MediaCardGalleryWithTextBlock);
}